import { render } from "./modalUpdateProfile.vue?vue&type=template&id=d0f32e2a&scoped=true"
import script from "./modalUpdateProfile.vue?vue&type=script&lang=js"
export * from "./modalUpdateProfile.vue?vue&type=script&lang=js"

import "./modalUpdateProfile.vue?vue&type=style&index=0&id=d0f32e2a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f32e2a"]])

export default __exports__